import { render } from "./DiscountsCreate.vue?vue&type=template&id=2bf52098"
import script from "./DiscountsCreate.vue?vue&type=script&lang=js"
export * from "./DiscountsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__